export type CarryThroughChannel =
  | 'assertion'
  | 'capture'
  | 'screenshot'
  | 'scroll'
  | 'python'
  | 'extract_table';

export type LinkerStepActionPolicy =
  | { kind: 'carry-through'; channel: CarryThroughChannel }
  | { kind: 'agent-only' }
  | { kind: 'linkable' };

export const CARRY_THROUGH_CHANNELS: Readonly<Partial<Record<string, CarryThroughChannel>>> = {
  verify: 'assertion',
  capture: 'capture',
  screenshot: 'screenshot',
  scroll: 'scroll',
  python_execute: 'python',
  extract_table: 'extract_table',
};

export const AGENT_ONLY_ACTIONS: ReadonlySet<string> = new Set([
  'agent_loop',
  'verify_download',
  'verify_download_content',
  'other',
]);

export function classifyLinkerStepAction(action: string): LinkerStepActionPolicy {
  const channel = CARRY_THROUGH_CHANNELS[action];
  if (channel) return { kind: 'carry-through', channel };
  if (AGENT_ONLY_ACTIONS.has(action)) return { kind: 'agent-only' };
  return { kind: 'linkable' };
}

export function isLinkableStepAction(action: string): boolean {
  return classifyLinkerStepAction(action).kind === 'linkable';
}
